import { Observable, catchError, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiErrorMapper, BASE_API_URL } from '@navstation-portal/shared/util/api';
import { GetVesselSpecResponse, ShipInformation } from '@navstation-portal/vessels/data-model/vessel';

@Injectable({ providedIn: 'root' })
export class VesselSpecService {
  private http = inject(HttpClient);
  private readonly baseUrl = inject(BASE_API_URL);
  private apiError = inject(ApiErrorMapper).forFeature('VesselSpec');

  getVesselSpec(vesselId: string): Observable<GetVesselSpecResponse> {
    return this.http
      .get<GetVesselSpecResponse>(`${this.baseUrl}/vessels/${vesselId}/vesselInformation`)
      .pipe(catchError(this.apiError.toApiError('getting the vessel spec')));
  }

  updateVesselSpec(
    vesselId: string,
    body: {
      information: Record<string, unknown>;
      form: Record<string, unknown>;
    }
  ) {
    if (!vesselId || !body) return throwError(() => new Error('data is required'));

    return this.http
      .post<ShipInformation>(`${this.baseUrl}/vessels/${vesselId}/vesselInformation`, body)
      .pipe(catchError(this.apiError.toApiError('updating vessel information')));
  }
}
